import {Consts} from "../../pages/consts";
import {useTranslation} from "react-i18next";
import {useState} from "react";
import {getInputFocusStyle} from "../../pages/utils";

const DayTimeIntake = ({index, intake, onSetIntake}) => {
  const {t} = useTranslation();
  const [dosage, setDosage] = useState(isNaN(intake?.dosage) ? 0 : intake?.dosage);
  const [intakeTime, setIntakeTime] = useState(intake?.intakeTime);
  const [isDosageFieldFocused, setIsDosageFieldFocused] = useState(false);

  const handleChangeDosage = (e) => {
    setDosage(e.target.value);

    let dosage = 0;

    if(!isNaN(e.target.value)){
      dosage = +e.target.value;
    }

    onSetIntake({...intake, dosage}, index);
  }

  const handleChangeIntakeTime = (e) => {
    setIntakeTime(e.target.value);
    onSetIntake({...intake, intakeTime: e.target.value}, index);
  }

  const isCompleted = !isNaN(intake?.dosage) && intake?.dosage > 0;

  return (
    <article className="daytime-intake-card">
      <header className="daytime-intake-card__header">
        <span className={`daytime-intake-card__title ${isCompleted ? "daytime-intake-card__title--completed" : ""}`}>
          { t(Consts.DAY_TIME_NAMES[index]) }
        </span>
      </header>

      <div className="daytime-intake-card__field">
        <label className="daytime-intake-card__label">{ t("dosage") }*</label>
        <div className="daytime-intake-card__input-group">
          <input
            value={ dosage }
            name={ Consts.DAY_TIME_NAMES[index] }
            type={ Consts.NUMBER }
            min="0"
            onFocus={() => setIsDosageFieldFocused(true)}
            onBlur={() => setIsDosageFieldFocused(false)}
            onChange={ (e) => handleChangeDosage(e) }
            className="form-input daytime-intake-card__input"
            style={getInputFocusStyle(isDosageFieldFocused)}
          />
          <span className="daytime-intake-card__unit">
            { t(intake?.dosageUnit?.dosageUnit) }
          </span>
        </div>
      </div>

      <div className="daytime-intake-card__field">
        <label className="daytime-intake-card__label">{ t("time") }</label>
        <input
          value={ intakeTime }
          name={ Consts.DAY_TIME_NAMES[index] }
          type={ Consts.TIME }
          onChange={ (e) => handleChangeIntakeTime(e) }
          className="form-input daytime-intake-card__input daytime-intake-card__input--time"
        />
      </div>
    </article>
  );
}

export default DayTimeIntake;